// extracted by mini-css-extract-plugin
module.exports = {"description":"ContentItem_description__a1WXd","container":"ContentItem_container__yMF3S","link":"ContentItem_link___vx_v"};